export enum Report {
    FullAnnualReport = 1
}